export class SummaryDepositModel {
    public TotalAmountStoreVN!: number;
    public TotalLeftStoreVN!: number;
    public TotalStatusAll!: number;
    public TotalStatus1!: number;
    public TotalStatus7!: number;
    public TotalStatus9!: number;
    public TotalStatus10!: number;
    public TotalStatus11!: number;
    public TotalStatus12!: number;
    public TotalStatus16!: number;
}